import { useState, useRef, useMemo } from "react";
import "./BookAppointment.css";
import { formatDateWOYear, formatValue, getApiCall, getBirthDayAndAnniversary, getDayOfToday, handleProductAndServiceGst, postApiData } from "../../utils/services";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProducts,
  newUpdateService,
  productAdded,
  removeAppointmentProductsData,
  serviceAdded,
  updateProducts,
} from "../../redux/actions";
import { deletItems } from "../../redux/actions";
import { MdDeleteOutline } from "react-icons/md";
import TimePicker from "rc-time-picker";
import { FaSearch } from "react-icons/fa";
import "rc-time-picker/assets/index.css";
import moment from "moment";
import { toast } from "react-hot-toast";
import NormalRadio from "../../components/customInput/NormalRadio";
import NormalInput from "../../components/customInput/NormalInput";
import NormalSelect from "../../components/customInput/NormalSelect";
import AddCustomerModal from "../../components/modals/AddCustomerModal";
import useDebouncer from "../../utils/hooks/useDebouncer";
import { fetchParlors } from "../../redux/reducers";
const formatDate = (date) => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // January is 0!
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};
const BookAppointment = ({ onTabChange }) => {
  const gstToken = localStorage.getItem("gstApplied");
  const gstApplied = (gstToken === "true")
  const [loading, setLoading] = useState(false);
  const serviceRef = useRef(null)
  const productRef = useRef(null)
  const customerRef = useRef(null)

  const { debouncedFunction } = useDebouncer();
  const [searchService, setSearchService] = useState("")
  const [searchServices, setSearchServices] = useState([])
  const [showSearchResults, setShowSearchResults] = useState(false);
  const { parlorLoading, parlorData } = useSelector((state) => state.parlorReducer);
  const parlorServices = parlorData?.services || [];
  const parlorProducts = parlorData?.products || [];
  const [customerDetails, setCustomerDetails] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    gender: "F",
    'dob-date': "",
    'dob-month': "",
    'aniversary-date': "",
    'aniversary-month': "",
    dob: '',
    aniversary: '',
    gstNumber: "",
    note: ""
  });
  const [appointmentDetails, setAppointmentDetails] = useState({

    date: formatDate(new Date()),
    time: ''

  })
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useState([]);
  const searchContainerRef = useRef(null);
  const productContainerRef = useRef(null);

  const [staffData, setStaffData] = useState([]);

  const [discount, setDiscount] = useState(0);
  const [membershipitem, setMemberShipItem] = useState(null);
  const [activeMembership, setActiveMemberShip] = useState({});
  const [memberShipStatus, setMemberShipStatus] = useState(false);
  // product table state
  const activemember = membershipitem?.activeMembership;

  const [applyDisountPer, setApplyDiscountPer] = useState(0);
  const [searchProduct, setsearchProduct] = useState("");
  const [showProdDropdown, setShowProdDropdown] = useState(false);
  const [showSearchProduct, setShowSearchProduct] = useState([]);
  const x = useSelector((store) => store.serviceAddReducer.serviceData);

  // useEffect(() => {
  //   setServices(x);
  // }, [x]);

  const appFields = [
    "date",
    "time"
  ]
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (appFields.includes(name)) {

      setAppointmentDetails((prev) => ({
        ...prev,
        [name]: value
      }))
    }
    else {
      setCustomerDetails((prev) => ({
        ...prev,
        [name]: name === "phoneNumber" ? value.slice(0, 10) : value,
      }));
      if (name === "gender") {
        setServiceSelection({
          ...serviceSelection,
          category: "",
          subCategory: "",
          miniSubcategory: "",



        });

      }
    }


  };
  const membershipPress = (e) => {
    if (e.target.value) {
      const activeMemb = activemember?.find((elm) => elm._id === e.target.value);
      if (activeMemb?.hasOwnProperty("dailyDiscount")) {
        let discountData = activeMemb?.dailyDiscount;
        const day = getDayOfToday();
        const todayDiscount = Math.max(discount || 0, discountData[`${day}`] || 0);
        const { hasBirthday, hasAnniversary } = getBirthDayAndAnniversary(customerDetails?.dob, customerDetails?.aniversary);
        //  console.log(hasBirthday,hasAnniversary,activeMemb)
        let birthdayDiscount = hasBirthday ? activeMemb?.bdDiscount : 0
        let anniversaryDiscount = hasAnniversary ? activeMemb?.anvDiscount : 0
        //  console.log(birthdayDiscount,anniversaryDiscount,customerDetails?.dob,customerDetails?.aniversary,customerDetails)
        setDiscount(Math.max(todayDiscount, birthdayDiscount || 0, anniversaryDiscount || 0, discount));
        setActiveMemberShip(activeMemb);
        setMemberShipStatus(true)
        toast.success("membership Applied")


      }
      else {
        if (activeMemb?.discount) {
          setDiscount(activeMemb?.discount)
        }
        else if (activeMembership?.discount && !activeMemb?.discount) {
          setDiscount(0)
        }
        setActiveMemberShip(activeMemb);
        setMemberShipStatus(true)
        toast.success("membership Applied")

      }

    }
    else {
      setActiveMemberShip({});
      setMemberShipStatus(false);
      toast.success("membership Removed")
    }
  };
  const handleChangeServices = (e, index, type) => {
    const { name, value } = e.target;
    if (type === "services") {
      const newServices = [...x];
      if (name === "staff") {
        const splited = value.split("-");
        const Name = splited[1];
        const Id = splited[0];
        newServices[index] = {
          ...newServices[index],
          staffId: Id,
          staffName: Name,
        };

      }
      else {
        newServices[index] = {
          ...newServices[index],
          [name]: (name === "price") ? Math.max(0, +value) : value
        };
      }
      dispatch(newUpdateService(newServices))
    }
    else {
      const newProducts = [...productDataReducer];
      if (name === "staff") {
        const splited = value.split("-");
        const Name = splited[1];
        const Id = splited[0];
        newProducts[index] = {
          ...newProducts[index],
          staffId: Id,
          staffName: Name,
        };

      }
      else {
        newProducts[index] = {
          ...newProducts[index],
          [name]: (name === "price" || name === "quantity") ? Math.max(0, +value) : value
        };
      }
      dispatch(updateProducts(newProducts))
    }

  }

  useEffect(() => {
    const currentTime = moment()._d.toString();

    const timeString = currentTime.split(" ")[4];
    setAppointmentDetails((prev) => ({
      ...prev,
      time: timeString,
      date: formatDate(new Date())
    }))
  }, []);


  const handleTimeChange = (selectedTime) => {
    const timeString = selectedTime._d.toString().split(" ")[4];
    setAppointmentDetails((prev) => ({
      ...prev,
      time: timeString
    }))
  };

  const productDataReducer = useSelector(
    (store) => store.ProductAddReducer.ProductData
  );

  const subtotalPrice = x.reduce((accumulator, currentItem) => {
    return accumulator + Number(currentItem.price);
  }, 0) || 0;
  const productTotalPrice = productDataReducer.reduce(
    (accumulator, { price, quantity }) => {
      return accumulator + quantity * price;
    },
    0
  );
  const countdiscount = Math.floor((subtotalPrice * applyDisountPer) / 100);

  const payableAmount = formatValue(subtotalPrice - countdiscount);
  const serviceGst = gstApplied ? formatValue(payableAmount * 0.05) : 0;
  const serviceTotal = Math.round(payableAmount + serviceGst);

  const membershipCreditUsed = useMemo(() => {
    return memberShipStatus ? Math.max(0, Math.floor(Math.min(activeMembership?.creditsLeft || 0, serviceTotal))) : 0
  }, [activeMembership, serviceTotal])

  const totalProductServicePayable = Math.round(serviceTotal + productTotalPrice);
  const [serviceSelection, setServiceSelection] = useState({
    category: "",
    subCategory: "",
    miniSubcategory: "",
    staffId: "",
    price: 0,
    staffName: "",
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(event.target)
      ) {
        setShowSearchResults(false);
      }
      if (
        productContainerRef.current &&
        !productContainerRef.current.contains(event.target)
      ) {
        setShowProdDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // useEffect(() => {
  //   getApiCall(
  //     "salonService/getServiceCategory",

  //     (resp) => {
  //       setService(resp);
  //     },
  //     (error) => { }
  //   );
  // }, [customerDetails?.gender]);

  // api call for getting subcategory
  // const categorydata = {
  //   categoryName: serviceSelection.category,
  //   gender: customerDetails.gender,
  // };

  // useEffect(() => {
  //   postApiData(
  //     "salonService/getSubServiceCategory",
  //     categorydata,
  //     (resp) => {
  //       setSubService(resp);
  //     },
  //     (error) => { }
  //   );
  // }, [serviceSelection.category]);
  // const minicatgdata = {
  //   category: serviceSelection.category,
  //   gender: customerDetails.gender,
  //   subCategory: serviceSelection.subCategory,
  // };
  // useEffect(() => {
  //   postApiData(
  //     "salonService/getSuggestedSalonServices",
  //     minicatgdata,
  //     (resp) => {
  //       setMiniService(resp[0]);
  //     },
  //     (error) => { }
  //   );
  // }, [serviceSelection.subCategory]);

  useEffect(() => {
    getApiCall(
      "owner/getStaff",
      (res) => {
        setStaffData(res.filter((elm) => elm.isActive));
      },
      (error) => { }
    );
  }, []);

  const dispatch = useDispatch();
  // console.log(x,"services")
  // const handleServiceChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "miniSubcategory") {
  //     const splited = value.split("---");
  //     const price = splited[0];
  //     const val = splited[1];
  //     setServiceSelection({
  //       ...serviceSelection,
  //       miniSubcategory: value,
  //       price: +price,
  //       miniSub: val,
  //     });
  //   } else if (name === "staff") {
  //     const splited = value.split("-");
  //     const Name = splited[1];
  //     const Id = splited[0];

  //     setServiceSelection({
  //       ...serviceSelection,
  //       staffId: Id,
  //       satffName: Name,
  //     });
  //   } else {
  //     setServiceSelection((prev) => ({
  //       ...prev,
  //       [name]: name === "price" ? Math.max(0, +value) : value,
  //     }));
  //   }
  // };

  // const handldeAddButton = () => {
  //   const { miniSub, miniSubcategory, ...rest } = serviceSelection;

  //   const selected = {

  //     ...rest,
  //     miniSubcategory: miniSub,
  //   };
  //   const isEveryEmpty = Object.values(selected).some((elm) => !elm);
  //   if (isEveryEmpty) {
  //     return toast.error("Please Select All Fields");
  //   }
  //   dispatch(serviceAdded(selected));
  //   // alert("All service added")
  //   toast.success("All Service Added!!");
  // };
  const validate = (products) => {
    if (x?.length > 0) {
      let serviceValid = x.some((elm) => !elm.staffId || !elm.price)
      if (serviceValid) {
        serviceRef.current?.scrollIntoView({
          behavior: "smooth", // smooth scroll
          block: "start",     // start | center | end | nearest
        });
        toast.error("Please fill fields in services")
        return false;
      }

    }
    if (!customerDetails?.name) {
      customerRef.current?.scrollIntoView({
        behavior: "smooth", // smooth scroll
        block: "start",     // start | center | end | nearest
      });

      toast.error("Please Add Customer")
      return false;
    };

    if (products?.length > 0) {
      let fieldEmpty = products.some((elm) => !elm.staffId || !elm.price || !elm.quantity || !elm.gst)
      if (fieldEmpty) {

        productRef.current?.scrollIntoView({
          behavior: "smooth", // smooth scroll
          block: "start",     // start | center | end | nearest
        });
        toast.error("Please fill all fields in products")
        return false
      }
    }
    return true
  }

  const handldeBookAppointment = () => {
    const { name,
      phoneNumber,
      email,
      gender,
      gstNumber,
      note
    } = customerDetails;

    if (appointmentDetails.date < formatDate(new Date())) {
      toast.error("Previous dates are not allowed");
      return;
    }

    const { serviceGst, serviceSubTotal, serviceTotal, updatedProducts, productGstTotal, productBaseAmountTotal, productTotal } = handleProductAndServiceGst(payableAmount, productDataReducer, appointmentDetails?.date);

    if (!validate(updatedProducts)) return;
    const data = {
      services: x,
      customer: {
        name,
        phoneNumber,
        email,
        gender,
        dob: formatDateWOYear(customerDetails["dob-date"], customerDetails["dob-month"]),
        aniversary: formatDateWOYear(customerDetails["aniversary-date"], customerDetails["aniversary-month"]),
        gstNumber,
        note,
      },
      subTotal: subtotalPrice,
      serviceSubTotal: serviceSubTotal || 0,
      serviceGst: serviceGst || 0,
      serviceTotal: serviceTotal || 0,
      productGst: productGstTotal,
      productSubTotal: productBaseAmountTotal,
      productTotal,
      // total: subtotalPrice,
      total: totalProductServicePayable,
      // appointmentDate: date + "T" + time + ".000Z",
      appointmentDate: appointmentDetails?.date + "T" + appointmentDetails?.time + ".000Z",
      membershipUsed: memberShipStatus,
      isMembershipApplied: memberShipStatus,
      // membershipCreditUsed: +memberShip,
      // membershipCreditUsed: memberShipStatus ? +subTotalService : 0,
      membershipCreditUsed: memberShipStatus ? membershipCreditUsed : 0,
      products: updatedProducts,
      discount: +countdiscount,
      discountPercentage: applyDisountPer,
      membershipId: activeMembership?._id,
    };
    setLoading(true)

    postApiData(
      "appointment/bookAppointmentFromCrm",
      data,
      (resp) => {
        if (resp) {
          // alert("Appointment Booked Sucessfully");
          setLoading(false)
          toast.success("Appointment Booked Sucessfully");
          dispatch(removeAppointmentProductsData());
          onTabChange(1)

        }
      },
      (error) => {
        setLoading(false)
        // alert(" Booking Status Failed");
        toast.error("Booking status failed!");
      }
    );


  };
  // ...`
  const nameOnclick = (item) => {
    // e.preventDefault();

    setMemberShipItem(item);
    setCustomerDetails((prev) => ({
      ...prev,
      name: item.name,
      phoneNumber: item.phoneNumber,
      gstNumber: item?.gstNumber || "",
      note: item?.note || "",
      dob: item?.dob,
      aniversary: item?.aniversary
    }));

    setVisible(false);
  };

  // product name on click

  const productNameOnclick = (item) => {

    const selected = {
      ...item,
      price: isNaN(parseInt(item.price)) ? 1999 : parseInt(item.price),
      quantity: 1,
      gst: item?.gst || 18,

    }
    dispatch(productAdded(selected));
    toast.success("product added succesfully");
  };

  const serviceNameOnclick = (item) => {
    const selected = {
      ...item,
      category: item?.category,
      subCategory: item?.subCategory,
      miniSubcategory: item.name,
      price: isNaN(parseInt(item?.price)) ? 1999 : parseInt(item?.price),

    }
    dispatch(serviceAdded(selected));
    toast.success("service added")
  };

  const deleteService = (item) => {
    dispatch(deletItems(item));
  };
  const deleteProduct = (id) => {
    dispatch(deleteProducts(id));
  };

  const handleSubmit = () => {
    const payload = {
      ...customerDetails,
      dob: formatDateWOYear(customerDetails["dob-date"], customerDetails["dob-month"]),
      aniversary: formatDateWOYear(customerDetails["aniversary-date"], customerDetails["aniversary-month"]),

    }
    if (!payload?.phoneNumber || payload.phoneNumber?.length !== 10) {

      return toast.error("Enter Valid Phone Number")
    }
    if (!payload?.name) {

      return toast.error("Enter Valid Customer Name")
    }
    postApiData(
      "parlor/registerUserForCrm",
      payload,
      (resp) => {
        toast.success("Customer Added Sucessfully");
      },
      (error) => { }
    );
    closeModal();
  };

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  // const fetchProd = (data) => {
  //   postApiData(
  //     "inventory/getSuggestedProductOfSalon",
  //     data,
  //     (resp) => {
  //       setShowSearchProduct(resp.products);
  //     },
  //     (error) => { }
  //   );
  // }

  const matchProds = (searchTerm) => {
    const products = parlorProducts?.filter((product) => {
      const matches = product?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product?.brand?.toLowerCase().includes(searchTerm.toLowerCase());
      return matches
    })
    if (products?.length > 0)
      setShowProdDropdown(true)
    setShowSearchProduct(products)


  }

  // on search product click
  const searchProductOnchange = (e) => {
    setsearchProduct(e.target.value);

    debouncedFunction(matchProds, 200, e.target.value)

  };
  const matchesSearch = (searchTerm) => {
    const services = parlorServices?.filter((service) => {
      const matches = service?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        service?.subCategory?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        service?.category?.toLowerCase().includes(searchTerm.toLowerCase());
      return matches
    })
    if (services?.length > 0)
      setShowSearchResults(true)
    setSearchServices(services)


  }


  const searchServiceOnchange = (e) => {
    const val = e.target.value
    setSearchService(val);
    debouncedFunction(matchesSearch, 300, val)

  };
  const applyDiscount = (discount) => {
    setApplyDiscountPer(discount);
    // alert("Discount Added sucessfully");
    if (discount)
      toast.success("Discount Added Successfully");
  };



  const fetchUser = () => {

    setVisible(true);
    const data = {
      phoneNumber: customerDetails?.phoneNumber,
    };
    postApiData(
      "user/searchUser",
      data,
      (resp) => {
        setUserData(resp);
      },
      (error) => { }
    );

  }

  // const addproductPress = (
  // ) => {
  //   if (!selectedProduct) return toast.error("Please Select Product");

  //   const { quantity, // Adding quantity key
  //     staffId,
  //     staffName, price,gst } = selectedProduct
  //     if (!quantity || quantity === "0") {
  //       toast.error("Please Enter Quantiy");

  //       return;
  //     }
  //     if (!price || price === "0") {
  //       toast.error("Please Enter Price");

  //       return;
  //     }
  //     if (!staffId || !staffName) {
  //       toast.error("Please Select Staff");

  //       return;
  //   }
  //   if (!price) {
  //     toast.error("Please Select Product");

  //     return;
  //   }
  //   if (!gst) {
  //     toast.error("Please Select gst");

  //     return;
  //   }

  //   // productQnt,productStaffid


  //   dispatch(productAdded(selectedProduct));
  //   toast.success("product added succesfully");
  // };


  // useEffect(() => {
  //   console.log(x, productDataReducer, "data")
  // }, [x, productDataReducer])

  //   const handleProductChange = (e) => {
  //     const { name, value } = e.target;
  //     if (name === 'staffName') {
  //       const splited = value.split("-");
  //       const Name = splited[1];
  //       const Id = splited[0];
  //       setSelectedProduct((prev) => ({
  //         ...prev,
  //         staffId: Id,
  //         staffName: Name,
  //       }));

  //     }
  //     else {

  //       setSelectedProduct((prev) => ({
  //         ...prev,
  //         [name]: (name === "price" || name === "quantity") ? Math.max(0, +value) :(name==="gst"&&name==="quantity")?+value: value
  //     }))
  //   }


  // }


  const genderFields = [
    {
      name: "Male",
      value: "M",
    },
    {
      name: "Female",
      value: "F",
    },
  ];
  // const servicesFields = [

  //   {
  //     name: "category",
  //     label: "Add Service"
  //   },
  //   {
  //     name: "subCategory",
  //     label: "Category"
  //   },
  //   {
  //     name: "miniSubcategory",
  //     label: "Sub Category"

  //   },
  //   {
  //     name: "price",
  //     label: "Price",
  //     type: "number",
  //     placeholder: "Enter Price"

  //   },
  //   {
  //     name: "staff",
  //     label: "Select Staff"
  //   },
  //   // {
  //     //   name: "product",
  //     //   label: "Search Product",
  //   //   type: "text",
  //   //   placeholder: "Product Name"
  //   // },

  // ];
  const addCustomerFields = [
    {
      name: "name",
      label: "Enter Name",
      placeholder: "Enter Name",
      value: customerDetails.name,
    },
    {
      name: "phoneNumber",
      label: "Mobile Number",
      placeholder: "Enter Mobile Number",
      value: customerDetails.phoneNumber,
    },
    {
      name: "email",
      label: "Email Address",
      value: customerDetails.email,

      placeholder: "Enter Email Address",
    },
    {
      name: "gender",
      label: "Gender",
      value: customerDetails.gender,
      options: genderFields,
    },
    {
      name: "dob",
      label: "Birthday",
      value1: customerDetails["dob-date"],
      value2: customerDetails["dob-month"],
      placeholder: "Enter Aniversary",
    },
    {
      name: "aniversary",
      label: "Aniversary",
      value1: customerDetails["aniversary-date"],
      value2: customerDetails["aniversary-month"],
      placeholder: "Enter Aniversary",
    },
    {
      name: "gstNumber",
      label: "Gst Number",
      value: customerDetails?.gstNumber,
      placeholder: "Gst Number",
    },
  ];

  // const servicesOptions = {
  //   category: service,
  //   subCategory: subservice,
  //   miniSubcategory: miniservice?.services?.map((elm) => ({
  //     name: elm.name,
  //     value: `${elm.price}---${elm.name}`,
  //   })),
  //   staff: staffData?.map((elm) => ({
  //     name: elm.name,
  //     value: `${elm._id}-${elm.name}`,
  //   })),
  // };
  const customerDetailsArray = [
    { label: "NAME", value: customerDetails?.name },
    {
      label: "MEMBERSHIP",
      value:
        membershipitem?.activeMembership?.length > 0 ? "Active" : "Inactive",
    },
    { label: "TOTAL VISITS", value: 0 },
    { label: "CARD ON FILE", value: 0 },
    { label: "LAST VISIT", value: 0 },
    { label: "POINTS", value: 0 },
  ];

  const paymentDetailsArray = [
    { label: "SERVICES", value: formatValue(subtotalPrice) },
    { label: "DISCOUNT", value: `- ${countdiscount}` },
    { label: "SUBTOTAL", value: ` ${payableAmount}` },
    (gstApplied && ({ label: "SERVICE GST", value: formatValue(serviceGst) })),
    { label: "SERVICE TOTAL ", value: formatValue(serviceTotal) },
    { label: "PRODUCT PRICE", value: formatValue(productTotalPrice) },
    { label: "PAYABLE AMOUNT", value: formatValue(totalProductServicePayable) },
    membershipCreditUsed && { label: "MEMBERSHIP CREDIT USED", value: `- ${membershipCreditUsed}` },
  ]?.filter(Boolean);
  const todayDate = formatDate(new Date());
  const customerFields = [
    {
      name: "phoneNumber",
      label: "Search by Phone or Name",
      placeholder: "9876543210",
      value: customerDetails.phoneNumber,
    },

    {
      name: "date",
      label: "Date",
      type: 'date',
      value: appointmentDetails?.date,
      min: todayDate,
      placeholder: "DD-MM-YYYY"

    },
    {
      name: "time",
      label: "Time",
      value: appointmentDetails?.time,
      placeholder: "DD-MM-YYYY"

    },
    {
      name: "note",
      label: "Note",
      value: customerDetails?.note,
      placeholder: "Additional Info"

    },
    {
      name: "gstNumber",
      label: "Customer Gst",
      value: customerDetails?.gstNumber,
      placeholder: "Gst Number"

    },

  ]
  const gstOption = [
    {
      name: "18%",
      value: 18
    },
    {
      name: "5%",
      value: 5
    }
  ]

  // const productFields = [
  //   {
  //     name: "name",
  //     label: "Product Name",
  //     placeholder: "Product Name",
  //     value: selectedProduct?.name,
  //   },
  //   {
  //     name: "price",
  //     label: "Price",
  //     type: "Number",              
  //     placeholder: "Price",
  //     value: selectedProduct?.price,
  //   },
  //   {
  //     name: "brand",
  //     label: "Brand",
  //     value: selectedProduct?.brand,
  //     readOnly: true,
  //     placeholder: "Brand",
  //   },
  //   {
  //     name: "quantity",
  //     label: "Quantity",
  //     type: "number",
  //     value: selectedProduct?.quantity,
  //     placeholder: "Quantity",
  //   },
  //   {
  //     name: "gst",
  //     label: "Gst",
  //     type: "select",
  //     value: selectedProduct?.gst,
  //     options:gstOption,
  //     placeholder: "Gst %",
  //   },
  //   {
  //     name: "staffName",
  //     label: "Select Staff",
  //     value: `${selectedProduct?.staffId}-${selectedProduct?.staffName}`,
  //     options: staffData?.map((item) => ({ name: item?.name, value: `${item._id}-${item.name}` }))


  //   }
  // ]
  const discounFields = [
    {
      label: "Discount Percentage",
      name: "discount",
      placeholder: "Discount %",
      value: discount,
      type: "number",
      onChange: (e) => setDiscount(Math.min(Math.max(e.target.value, 0), 100))
    },
    {
      label: "Membership",
      name: "membership",
      value: activeMembership?._id,
      options: activemember?.map((item) => ({
        name: `${item.name}-${item.creditsLeft}`,
        value: item._id,
      })),
      onChange: membershipPress,
    },
    {
      label: "Membership Balance",
      name: "membershipBalance",
      value: activeMembership?.creditsLeft || 0,
      readOnly: true
    }
  ]
  const fields = [
    { key: "index", label: "#", type: "text" },
    { key: "miniSubcategory", label: "Name", type: "text" },
    { key: "category", label: "Category", type: "text" },
    { key: "subCategory", label: "Sub Category", type: "text" },
    { key: "price", label: "Price", type: "input" },
    { key: "staff", label: "Staff", type: "select" },
    { key: "action", label: "Action", type: "action" },
  ];


  // Common cell class
  // const cellClass =
  //   "border-none text-sm 2xl:text-md text-ternaryGray font-normal";



  useEffect(() => {
    if (customerDetails?.phoneNumber) {
      debouncedFunction(fetchUser, 800)
    }
  }, [customerDetails?.phoneNumber])
  useEffect(() => {
    if (discount >= 0) {
      debouncedFunction(applyDiscount, 800, discount)
    }

  }, [discount])


  // useEffect(()=>{

  //   console.log(subtotalPrice,
  //     // total: subtotalPrice,
  //     totalProductServicePayable,payableAmount,"total")
  //   },[subtotalPrice,totalProductServicePayable,payableAmount])

  const tableFields = [customerDetailsArray, paymentDetailsArray];

  useEffect(() => {
    dispatch(fetchParlors());
  }, [dispatch]);
  // console.log(serviceSelection,"serviceSelection")
  return (
    <>
      <div className="mx-auto ">
        {/* customer details */}
        <div className="rounded-[10px] bg-white shadow-tab border p-5 mb-9">
          <div ref={customerRef} className="flex flex-col sm:flex-row items-start sm:items-center mb-9 justify-between gap-3">
            <h2 className="font-normal leading-[20px]   text-black text-[24px]">Customer Details</h2>
            <button
              onClick={openModal}
              className="w-full sm:w-[190px] bg-ternary font-normal h-[36px] flex items-center justify-center active:bg-ternary/90 transition-colors ease-in duration-100 rounded-[16px] text-white text-sm leading-[24px]">Add New Customer</button>
          </div>
          <div className="flex flex-col mb-9  gap-5">
            <h1 className="text-black  font-normal text-md">
              Gender
            </h1>
            <div className="flex items-center gap-9">
              {genderFields.map((elm, index) => {
                return (
                  <NormalRadio
                    key={index}
                    onChange={handleChange}
                    checked={customerDetails.gender === elm.value}
                    name="gender"
                    label={elm.name}
                    value={elm.value}
                  />
                );
              })}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-9 ">

            {
              customerFields?.map((customer, index) => {
                const { name, label, placeholder, value, readOnly, type, min } = customer
                return (
                  <div className="relative">
                    <div className="flex flex-col gap-1">
                      {name !== "time" ? <NormalInput
                        key={index}
                        name={name}
                        type={type}
                        min={min}
                        label={label}
                        disabled={readOnly}
                        onChange={handleChange}
                        placeholder={placeholder}
                        value={value}
                        inputStyles={{
                          'borderRadius': '16px'

                        }}
                        lableStyles={{
                          'fontWeight': '400',
                          "fontSize": "16px",
                          'color': '#000000'
                        }}



                      /> :
                        <div className="flex time flex-col gap-1">
                          <p className="text-md mb-1  text-black">Time</p>

                          <TimePicker
                            placeholder="Select Time"
                            use12Hours
                            allowEmpty={false}
                            showSecond={false}
                            focusOnOpen={true}
                            format="hh:mm A"
                            onChange={handleTimeChange}
                            inputIcon
                            className="rounded-[16px] border border-primaryGray text-black py-[12px] px-[27px] text-sm"

                            defaultValue={moment()}
                            defaultOpenValue={moment()}
                          />

                        </div>}
                    </div>
                    {visible && name === "phoneNumber" && userData.length > 0 && (
                      <div
                        className="absolute -bottom-[110px] h-[110px] w-full py-2 overflow-auto border-2 border-gray-200 bg-white shadow-xl rounded-lg z-[2]"
                      >
                        {userData.length > 0 &&
                          userData?.map((item, index) => {
                            return (
                              <div
                                key={index}
                                style={{ display: "flex" }}
                                onClick={() => nameOnclick(item)}
                                className="flex items-center gap-2 px-4 py-2 mb-0 transition-all duration-300 ease-in-out transform hover:bg-[#f5da42] hover:scale-95 cursor-pointer"
                              >
                                <p className="mr-2 capitalize font-semibold">{item.name}</p>
                                <p className="font-semibold">
                                  {item.phoneNumber}
                                </p>
                                {item?.note && <p className="font-bold">
                                  -{item?.note}
                                </p>}
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                )
              })
            }
          </div>
        </div>

        {/* service Detail */}
        <div ref={serviceRef} className="rounded-[10px] bg-secondaryGray shadow-tab border p-5 mb-9">

          <div className="flex items-center gap-6  mb-9 ">
            <h2 className="font-normal text-start leading-[20px]  text-black text-[24px]">Service Detail</h2>
            <span className="border text-black text-[13px] border-gray2 w-[27px] flex items-center justify-center rounded-[16px] h-[21px]">{x?.length > 9 ? '9+' : x?.length + "+"}</span>
          </div>

          {x.length > 0 && (
            <div className="w-full table-responsive">
              <table className="w-full">
                <thead>
                  <tr>

                    {fields.map((f) => (
                      <th
                        key={f.key}
                        className="border-none overflow-hidden text-ellipsis text-sm font-normal text-gray2 2xl:text-md"
                      >
                        {f.label}
                      </th>
                    ))}
                  </tr>

                </thead>
                <tbody>
                  {x?.map((item, index) => (
                    <tr key={index}>
                      <td className="border-none text-sm 2xl:text-md text-gray2 font-normal">{index + 1}</td>
                      <td className="border-none text-sm 2xl:text-md text-gray2 font-normal">{item?.miniSubcategory}</td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal">{item?.category}</td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal">{item?.subCategory}</td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal"><NormalInput
                        name="price"
                        type="number"
                        value={item?.price}
                        onChange={(e) => handleChangeServices(e, index, "services")}
                        inputStyles={{ width: "120px", padding: "5px 10px" }}
                      /></td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal">
                        <NormalSelect
                          name="staff"
                          label={""}
                          options={staffData?.map((item) => ({ name: item?.name, value: `${item._id}-${item.name}` }))}
                          inputStyles={{ width: "150px", padding: "5px 10px" }}

                          onChange={(e) => handleChangeServices(e, index, "services")}
                          value={`${item.staffId}-${item.staffName}`}

                        />
                      </td>
                      <td className="border-none text-sm 2xl:text-md text-gray2 font-normal">
                        {" "}
                        <MdDeleteOutline
                          onClick={() => deleteService(index)}
                          className="text-xl text-red-600 font-bold cursor-pointer"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}


        </div>
        {/* service select */}
        <div className="rounded-[10px] bg-white shadow-tab border p-5 mb-9">
          <h2 className="font-normal text-start leading-[20px] mb-9   text-black text-[24px]">Select Service</h2>
          <div className="relative w-full flex flex-col gap-1 mb-5">
            <NormalInput
              name="searchService"
              label="Search Service"
              placeholder="Service Name"
              onChange={searchServiceOnchange}

              value={searchService}
              inputStyles={{
                'borderRadius': '16px'

              }}
              lableStyles={{
                'fontWeight': '400',
                "fontSize": "16px",
                'color': '#000000'
              }}



            />
            <FaSearch className="absolute right-4  bottom-[13px] text-xl " />
            {searchServices?.length > 0 && showSearchResults && (
              <div
                ref={searchContainerRef}
                className="absolute top-[80px] w-full p-2  max-h-[350px]  overflow-y-auto bg-white shadow-lg z-[1000]"
              >
                {searchServices?.map((item) => {
                  return (
                    <div
                      className="flex justify-between  bg-gray-100 mb-2 last:mb-0 items-center px-4 py-2 border shadow-md cursor-pointer"
                    >
                      <div className="flex gap-6  cursor-pointer">

                        <p className="mr-2 capitalize font-medium">{item.category}</p>
                        <p className="mr-2 capitalize font-medium">{item.subCategory}</p>
                        <p className="mr-2 capitalize font-semibold">{item.name}</p>
                        <p className="mr-2 capitalize font-semibold">₹{item.price}</p>
                        <p className="mr-2 capitalize font-semibold">{item.gender}</p>
                      </div>
                      <button onClick={() => serviceNameOnclick(item)} className="bg-ternary hover:scale-105 delay-100 duration-100 transition-all ease-in px-4 rounded-lg py-2 text-white font-bold">Add</button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-9 ">
            {/* {
              servicesFields?.map((customer, index) => {
                const { name, label, placeholder, type } = customer
                const value = serviceSelection[name];
                const options = servicesOptions[name]
                return (
                  <div key={index} className="relative">
                    <div className="flex flex-col gap-1">

                      {name === "price" ?

                        <NormalInput
                          name={name}
                          label={label}
                          type={type}
                          onChange={handleServiceChange}
                          placeholder={placeholder}
                          value={value}
                          inputStyles={{
                            'borderRadius': '16px'

                          }}
                          lableStyles={{
                            'fontWeight': '400',
                            "fontSize": "16px",
                            'color': '#000000'
                          }}



                        />
                        : <NormalSelect

                          name={name}
                          label={label}
                          options={options}
                          onChange={handleServiceChange}
                          value={value}
                          inputStyles={{
                            'borderRadius': '16px'

                          }}
                          lableStyles={{
                            'fontWeight': '400',
                            "fontSize": "16px",
                            'color': '#000000'
                          }}



                        />}
                    </div>

                  </div>
                )
              })
            } */}
          </div>
          {/* <div className="flex justify-end mt-5">

            <button onClick={handldeAddButton}
              className="bg-black text-white rounded-[16px] w-[190px] text-sm font-normal ">Add Service</button>
          </div> */}

        </div>
        {/* product Detail  */}
        <div className="rounded-[10px] bg-secondaryGray shadow-tab border p-5 mb-9">
          <div className="flex items-center gap-6  mb-9 ">
            <h2 className="font-normal text-start leading-[20px]  text-black text-[24px]">Product Detail</h2>
            <span className="border text-black text-[13px] border-gray2 w-[27px] flex items-center justify-center rounded-[16px] h-[21px]">{productDataReducer?.length > 9 ? '9+' : productDataReducer?.length + "+"}</span>
          </div>

          {productDataReducer?.length > 0 && (
            <div className="w-full table-responsive">
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">#</th>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">Name</th>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">Price</th>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">Brand</th>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">Quantity</th>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">Gst</th>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">Staff</th>
                    <th className="border-none text-sm font-normal text-gray2 2xl:text-md">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {productDataReducer?.map((item, index) => (
                    <tr key={index}>
                      <td className="border-none text-sm 2xl:text-md text-gray2 font-normal">{index + 1}</td>
                      <td className="border-none text-sm 2xl:text-md text-gray2 font-normal">{item?.name}</td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal"><NormalInput
                        name="price"
                        type="number"
                        value={item?.price}
                        onChange={(e) => handleChangeServices(e, index, "products")}
                        inputStyles={{ width: "120px", padding: "5px 10px" }}
                      /></td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal">{item?.brand}</td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal"><NormalInput
                        name="quantity"
                        type="number"
                        value={item?.quantity}
                        onChange={(e) => handleChangeServices(e, index, "products")}
                        inputStyles={{ width: "120px", padding: "5px 10px" }}
                      /></td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal"> <NormalSelect
                        name="gst"
                        label={""}
                        options={gstOption}
                        inputStyles={{ width: "150px", padding: "5px 10px" }}

                        onChange={(e) => handleChangeServices(e, index, "products")}
                        value={item?.gst}

                      /></td>
                      <td className="border-none text-sm 2xl:text-md text-ternaryGray font-normal"> <NormalSelect
                        name="staff"
                        label={""}
                        options={staffData?.map((item) => ({ name: item?.name, value: `${item._id}-${item.name}` }))}
                        inputStyles={{ width: "150px", padding: "5px 10px" }}

                        onChange={(e) => handleChangeServices(e, index, "products")}
                        value={`${item.staffId}-${item.staffName}`}

                      /></td>
                      <td className="border-none text-sm 2xl:text-md text-gray2 font-normal">
                        {" "}
                        <MdDeleteOutline
                          onClick={() => deleteProduct(index)}
                          className="text-xl text-red-600 font-bold cursor-pointer"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

        </div>
        {/* product select */}
        <div ref={productRef} className="rounded-[10px] mb-9 bg-white border p-5 ">
          <h2 className="font-normal text-start leading-[20px] mb-9   text-black text-[24px]">Select Product</h2>
          <div className="relative w-full flex flex-col gap-1">
            <NormalInput
              name="product"
              label="Search Product"
              placeholder="Product Name"
              onChange={searchProductOnchange}

              value={searchProduct}
              inputStyles={{
                'borderRadius': '16px'

              }}
              lableStyles={{
                'fontWeight': '400',
                "fontSize": "16px",
                'color': '#000000'
              }}



            />
            <FaSearch className="absolute right-4  bottom-[13px] text-xl " />
            {showProdDropdown && showSearchProduct?.length > 0 && (
              <div
                ref={productContainerRef}
                className="absolute top-[80px] w-full  p-2 max-h-[300px]  overflow-y-auto bg-white shadow-lg z-[9]"
              >
                {showSearchProduct?.map((item) => {
                  return (
                    <div
                      className="flex justify-between  bg-gray-100 mb-2 last:mb-0 items-center px-4 py-2 border shadow-md  cursor-pointer"
                    >
                      <div className="flex gap-6  cursor-pointer">


                        <p className="mr-2 capitalize font-medium">{item.brand}</p>
                        <p className="mr-2 capitalize font-semibold">{item.name}</p>
                        <p className="mr-2 capitalize font-semibold">₹{item.price}</p>
                      </div>
                      <button onClick={() => productNameOnclick(item)} className="bg-ternary hover:scale-105 delay-100 duration-100 transition-all ease-in px-4 rounded-lg py-2 text-white font-bold">Add</button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-9">
            {
              productFields?.map((elm, index) => {
                const { name, label, placeholder, value, readOnly, type, options } = elm
                return (
                  <div key={index}
                    className="relative">
                    <div className="flex flex-col gap-1">
                      {name === "staffName"|| name==="gst" ? <NormalSelect

                        name={name}
                        label={label}
                        options={options}
                        onChange={handleProductChange}
                        value={value}
                        inputStyles={{
                          'borderRadius': '16px'

                        }}
                        lableStyles={{
                          'fontWeight': '400',
                          "fontSize": "16px",
                          'color': '#000000'
                        }}



                      /> : <NormalInput
                        name={name}
                        type={type}
                        label={label}
                        disabled={readOnly}
                        onChange={handleProductChange}
                        placeholder={placeholder}
                        value={value}
                        inputStyles={{
                          'borderRadius': '16px'

                        }}
                        lableStyles={{
                          'fontWeight': '400',
                          "fontSize": "16px",
                          'color': '#000000'
                        }}



                      />}
                    </div>  </div>
                )

              })

            }



          </div>
          <div className="flex justify-end mt-5">

            <button onClick={addproductPress}
              className="bg-black text-white rounded-[16px] w-[190px] text-sm font-normal ">Add Product</button>
          </div> */}

        </div>

        {/* Apply Discount */}
        <div className="rounded-[10px] bg-white shadow-tab border p-5 mb-9">

          <h2 className="font-normal text-start leading-[20px] mb-9 text-black text-[24px]">Apply Discount</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-9">
            {
              discounFields?.map((elm, index) => {
                const { name, label, placeholder, value, readOnly, type, options, onChange } = elm
                return (
                  <div key={index}
                    className="relative">
                    <div className="flex flex-col gap-1">
                      {name === "membership" ? <NormalSelect

                        name={name}
                        label={label}
                        options={options}
                        onChange={onChange}
                        value={value}
                        inputStyles={{
                          'borderRadius': '16px'

                        }}
                        lableStyles={{
                          'fontWeight': '400',
                          "fontSize": "16px",
                          'color': '#000000'
                        }}



                      /> : <NormalInput
                        name={name}
                        type={type}
                        label={label}
                        disabled={readOnly}
                        onChange={onChange}
                        placeholder={placeholder}
                        value={value}
                        inputStyles={{
                          'borderRadius': '16px'

                        }}
                        lableStyles={{
                          'fontWeight': '400',
                          "fontSize": "16px",
                          'color': '#000000'
                        }}



                      />}
                    </div>  </div>
                )

              })

            }



          </div>



        </div>
        {/* book appointment */}
        {customerDetails?.phoneNumber && (<div className="rounded-[10px] bg-secondaryGray shadow-tab border p-5 mb-9">
          <h2 className="font-normal text-start leading-[20px] mb-9 text-black text-[24px]">Booking Detail</h2>


          <div className="p-2 w-full   flex flex-col md:flex-row justify-between  items-start md:items-center gap-4">
            {tableFields.map((elm, idx) => {
              return (
                <div key={idx} className="w-full md:w-[40%] mb-auto ">
                  <table className="table-auto  w-full">
                    <thead></thead>
                    <tbody>
                      {elm?.map((item, index) => (
                        <tr key={index}>
                          <td className="font-normal text-black text-sm  2xl:text-md border-none px-4 py-2">
                            {item.label}
                          </td>
                          <td className=" font-normal text-right   text-sm 2xl:text-md border-none px-4 py-2 text-green-800">
                            {item.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
          <div className="flex justify-end mt-12">

            <button disabled={loading} onClick={handldeBookAppointment}
              className="bg-black text-white rounded-[16px] w-full max-w-[250px] text-sm font-normal ">Book Appointment</button>
          </div>

        </div>)}
        {loading && <div className="fixed z-20 top-0 bottom-0 h-full w-full right-0 left-0 bg-black/10 ">
          <div className="flex items-center justify-center h-full w-full">


            <div className="relative flex justify-center items-center">
              <div className="absolute animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-purple-500" />

            </div>

          </div>

        </div>}
        {/*  */}
        <AddCustomerModal
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          addCustomerFields={addCustomerFields}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          heading={"Add New Customer"}
        />



      </div>


    </>
  );
};

export default BookAppointment;
